import { KiloClass } from 'types/generated';

type RequiredReservationAndCancellationSettings = Required<KiloClass['reservationAndCancellationSettings']>;

export const getReservationAndCancellationSettings = (
  settings: KiloClass['reservationAndCancellationSettings'],
): RequiredReservationAndCancellationSettings => {
  return {
    reservationWindowOpenInterval: settings?.reservationWindowOpenInterval ?? 'day',
    reservationWindowOpenIntervalCount: settings?.reservationWindowOpenIntervalCount ?? 7,

    reservationWindowCloseInterval: settings?.reservationWindowCloseInterval ?? 'hour',
    reservationWindowCloseIntervalCount: settings?.reservationWindowCloseIntervalCount ?? 1,

    cancellationInterval: settings?.cancellationInterval ?? 'hour',
    cancellationIntervalCount: settings?.cancellationIntervalCount ?? 0,

    allowLateCancellation: settings?.allowLateCancellation ?? true,

    cancellationFee: settings?.cancellationFee ?? 0,

    cancellationCreditDeduction: settings?.cancellationCreditDeduction ?? true,

    noShowFee: settings?.noShowFee ?? 0,

    noShowCreditDeduction: settings?.noShowCreditDeduction ?? false,

    waitlistMax: settings?.waitlistMax ?? 5,
  };
};
